document.addEventListener('DOMContentLoaded', () => {
    const mapElem = document.querySelector('#map');
    if(mapElem) {
        const API_KEY = 'teKPGKtfqz02fBCpP6uR'
        const LAT_LNG = [mapElem.getAttribute('data-lat'), document.querySelector('#map').getAttribute('data-lng')]
        const mapConfig = {
            container: 'map', // container's id or the HTML element to render the map
            style: "019ad8cb-8d81-7dcf-9137-940c980846e2",
            zoom: 15,
            center: LAT_LNG,
            minZoom: 15,
            maxZoom: 15,
            scrollZoom: false
        }

        const iconPath = 'assets/images/icons/map/pin.png';
        const iconConfig = {
            'id': 'icon-layer',
            'type': 'symbol',
            'source': {
                'type': 'geojson',
                'data': {
                    'type': 'FeatureCollection',
                    'features': [{
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': LAT_LNG
                        }
                    }]
                }
            },
            'layout': {
                'icon-image': 'icon',
                'icon-size': 0.25,
                'icon-anchor': 'bottom',
                'icon-allow-overlap': true
            }
        };

        (maptilersdk as any)!.config.apiKey = API_KEY;
        const map = new maptilersdk.Map(mapConfig);
        map.on('load', async () => {
            const image = await map.loadImage(iconPath);
            map.addImage('icon', image.data);
            map.addLayer(iconConfig)
        })
    }
})